import { ReactElement } from 'react';
import { Stack, Typography, Tooltip } from '@mui/material';
import { HelpRounded as HelpIcon } from '@mui/icons-material';

import { DashboardVariantV2GiverStatusInfoWidgetCardHeaderProps } from './types';
import {
  DashboardVariantV2GiverStatusInfoWidgetCardHeaderContainer,
  DashboardVariantV2GiverStatusInfoWidgetCardHeaderTypographyCurrent,
  DashboardVariantV2GiverStatusInfoWidgetCardHeaderTypographyTotal,
  DashboardVariantV2GiverStatusInfoWidgetCardHeaderIconImg,
} from './styles';

const DashboardVariantV2GiverStatusInfoWidgetCardHeader = ({
  statistics,
  icon,
  title,
  info,
  withDivider = true,
}: DashboardVariantV2GiverStatusInfoWidgetCardHeaderProps): ReactElement => (
  <DashboardVariantV2GiverStatusInfoWidgetCardHeaderContainer
    withDivider={withDivider}
  >
    {info}

    <Stack spacing={1} flex={1}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        minHeight={50}
      >
        <Stack spacing={1} direction="row" alignItems="center">
          <DashboardVariantV2GiverStatusInfoWidgetCardHeaderTypographyCurrent>
            {statistics.current}
          </DashboardVariantV2GiverStatusInfoWidgetCardHeaderTypographyCurrent>

          <DashboardVariantV2GiverStatusInfoWidgetCardHeaderTypographyTotal color="action.disabled">
            / {statistics.total}
          </DashboardVariantV2GiverStatusInfoWidgetCardHeaderTypographyTotal>
        </Stack>

        <DashboardVariantV2GiverStatusInfoWidgetCardHeaderIconImg {...icon} />
      </Stack>

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <Stack spacing={1} direction="row">
          <Typography
            component="h6"
            variant="body1"
            fontWeight="bold"
            color="text.primary"
          >
            {title.text}
          </Typography>

          {title.tooltip && (
            <Tooltip title={title.tooltip} arrow placement="right">
              <HelpIcon color="disabled" sx={{ fontSize: 22 }} />
            </Tooltip>
          )}
        </Stack>
      </Stack>
    </Stack>
  </DashboardVariantV2GiverStatusInfoWidgetCardHeaderContainer>
);

export default DashboardVariantV2GiverStatusInfoWidgetCardHeader;
